/** Publiczne ID tagów Google (można nadpisać w .env). */
export const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim();
export const GADS_ID =
  process.env.NEXT_PUBLIC_GOOGLE_ADS_ID?.trim() || "AW-18293449812";
export const GTM_ID =
  process.env.NEXT_PUBLIC_GTM_ID?.trim() || "GTM-NBLTHHNR";

/** ID używane do załadowania gtag.js (GA4 ma pierwszeństwo). */
export const GTAG_PRIMARY_ID = GA_ID || GADS_ID;
